import React from 'react';
import { AlertCircle, CheckCircle, InfoIcon } from 'lucide-react';

const IconMap = {
  success: CheckCircle,
  warning: AlertCircle,
  insight: InfoIcon,
  error: AlertCircle,
};

export function InsightCard({ type = 'insight', title, message }) {
  const Icon = IconMap[type] || InfoIcon;
  const bgColor = {
    success: 'bg-green-50 dark:bg-green-900/20',
    warning: 'bg-yellow-50 dark:bg-yellow-900/20',
    insight: 'bg-blue-50 dark:bg-blue-900/20',
    error: 'bg-red-50 dark:bg-red-900/20',
  }[type] || 'bg-blue-50 dark:bg-blue-900/20';

  const iconColor = {
    success: 'text-green-600',
    warning: 'text-yellow-600',
    insight: 'text-blue-600',
    error: 'text-red-600',
  }[type] || 'text-blue-600';

  return (
    <div className={`${bgColor} rounded-lg border p-4`}>
      <div className="flex gap-3">
        <Icon className={`w-5 h-5 ${iconColor} flex-shrink-0 mt-0.5`} />
        <div>
          <h4 className="text-sm font-semibold text-gray-900 dark:text-white">{title}</h4>
          <p className="text-sm text-gray-700 dark:text-gray-300 mt-1">{message}</p>
        </div>
      </div>
    </div>
  );
}
